<template>
    <div>
        <div class>
            <Steps :active="6" :stepsShow=true align-center>
                <Step :title="$t('offering.offbase')" @click.native="on_click('offbaseAdd')" />
                <Step :title="$t('offering.offeringResources')" @click.native="on_click('offeringResourcesAdd')" />
                <Step :title="$t('offering.offconditionAdd')" @click.native="on_click('offconditionAdd')" />
                <Step :title="$t('offering.offnoticeAdd')" @click.native="on_click('offnoticeAdd')" />
                <Step :title="$t('offering.offpriceAdd')" @click.native="on_click('offpriceAdd')" />
                <Step :title="$t('offering.offinvestAdd')" @click.native="on_click('offinvestAdd')" />
                <Step :title="$t('offering.offabilityAdd')"  @click.native="on_click('offabilityAdd')" />
            </Steps>
        </div>
        <br/>
        <div class='divMessage'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ message }}</div>
        <br/>
        <el-card class="aui-card--fill"
                 shadow="never">
            <el-row>
                <el-col :span="2"><div class="grid-content" /></el-col>
                <el-col :span="20">
                    <el-table
                            :data="tableData"
                            border
                            style="width: 80%"
                            disabled
                    >
                        <el-table-column
                                prop="name"
                                label="职位"
                                width="180"
                                align="center"
                        />
                        <el-table-column
                                prop="address"
                                label="能力项"
                                align="center"
                        />
                    </el-table>
                </el-col>
            </el-row>

        </el-card>
        <div>
            <el-row style="float:right; margin-bottom: 60px;">
                <el-col :span="16"><div class="grid-content" /></el-col>
                <el-button @click="sendEdit" v-if = initIsShowEdit
                           type="primary">{{ $t("course.edit") }}</el-button>
                <el-button @click="tabRemove"
                           type="primary">{{ $t("course.return") }}</el-button>
            </el-row>
        </div>
    </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
// 基本信息   offbaseAdd
// 报名条件   offconditionAdd
// 报名通知   offnoticeAdd
// 价格相关   offpriceAdd
// 调查问卷   offinvestAdd
// 能力项设置 offabilityAdd
import Steps from '../../common/steps/index'
import Step from '../../common/steps/src/step'
export default {
// import引入的组件需要注入到对象中才能使用
  components: { Steps, Step },
  props: ['message', 'passOfferingId'],
  inject: ['toTop'],
  data () {
    return {
      initIsShowEdit:'',
      // message: '',
      dataIsSaveAll: '',
      courseId: '',
      tableData: [],
      // tableData: [{
      //   name: '客户关系经理',
      //   address: '客户导向，案例分析能力'
      // }, {
      //   name: 'MINI市场经理',
      //   address: '客户导向'
      // }],
      dataForm: {
        courseId: '',
        courseStatus: '20',
        offeringId: ''
      }
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {
      this.dataForm.offeringId = this.$route.query.offeringId
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {
    console.log('mounted')
  },
  beforeCreate () {
    console.log('beforeCreate')
  }, // 生命周期 - 创建之前
  beforeMount () {
    console.log('beforeMount')
  }, // 生命周期 - 挂载之前
  beforeUpdate () {
    console.log('beforeUpdate')
  }, // 生命周期 - 更新之前
  updated () {
    console.log('updated')
  }, // 生命周期 - 更新之后
  beforeDestroy () {
    console.log('beforeDestroy')
  }, // 生命周期 - 销毁之前
  destroyed () {
    console.log('destroyed')
  }, // 生命周期 - 销毁完成
  activated () {
    if (this.$route.query.offeringId !== undefined && this.$route.query.offeringId !== '') {
      // #TODO 再次进入页面初始化数据
      console.log('再次进入 abilityItems')
      console.log(this.$route.query.offeringId)
      this.init(this.$route.query.offeringId)
    }
      if (this.$route.query.isShowEdit !== undefined && this.$route.query.isShowEdit !== '') {
          this.initIsShowEdit = this.$route.query.isShowEdit
      }
  },
  // 方法集合
  methods: {
    sendEdit(){
      console.log("sendEdit")
      this.$router.push({ path: 'learning-offering-offeringEdit', query: { offeringId: this.dataForm.offeringId } })
    },
    // 设置初始化为空
    again () {
      // TODO data 数据设置为空
    },
    // 初始化数据
    init (offeringId) {
      // TODO data 初始化数据
      // TODO data 初始化数据
      // TODO data 初始化数据
      // TODO data 初始化数据
      // TODO data 初始化数据
      // TODO data 初始化数据
      // TODO data 初始化数据
    },
    // 保存方法
    btnSave () {
      // TODO 成功调用  this.sendSave()
    },
    // 发布
    btnRelease () {
      // TODO  成功调用 this.sendMsg()
      this.sendMsg()
    },
    // 向父页面传递消息 跳转下一页面
    sendMsg () {
      this.$emit('onShowModer', 'offeringEnd')
    },
    // 向父页面传递消息 保存页面
    sendSave () {
      this.$emit('onShowModer', 'offabilitySave')
    },
    // 点击导航跳转页面
    on_click (e) {
      this.$emit('onShowModer', e)
    },
    btnCancel () {
      this.$confirm('离开本页将不保存当前正在编辑的数据, 确定离开? ', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.tabRemove()
      }).catch((err) => {
        console.log(err)
      })
    },
    // 删除当前页面
    tabRemove () {
      let tabName = this.$store.state.contentTabsActiveName
      if (tabName === 'home') {
        return false
      }
      this.$store.state.contentTabs = this.$store.state.contentTabs.filter(item => item.name !== tabName)
      if (this.$store.state.contentTabs.length <= 0) {
        this.$store.state.sidebarMenuActiveName = this.$store.state.contentTabsActiveName = 'home'
        return false
      }
      // 当前选中tab被删除
      if (tabName === this.$store.state.contentTabsActiveName) {
        this.$router.push({ name: this.$store.state.contentTabs[this.$store.state.contentTabs.length - 1].name })
      }
    }
  }
}
</script>
<style lang='scss' scoped>
    // @import url(); 引入公共css类
    .grid-content {
        border-radius: 4px;
        min-height: 20px;
    }
</style>
